import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import z from 'zod';

import { DEFAULT_PAGE_SIZE } from '@/components/BaseTable/BaseTable';
import { SettingsPageLayout } from '@/components/Settings/SettingsPageLayout';
import { AdminTeams } from '@/components/Teams/AdminTeams';
import { useIsExactRouteMatch } from '@/hooks/useIsExactRouteMatch';
import { useUser } from '@/hooks/useUser';
import { searchParam } from '@/utils/router';
import { requiredSortingSearchParam } from '@/utils/tableSorting';

const teamsSearchSchema = z.object({
  tPageSize: z.number().default(DEFAULT_PAGE_SIZE).catch(DEFAULT_PAGE_SIZE),
  tPageIndex: z.number().default(0).catch(0),
  tSearch: searchParam().optional(),
  tNew: z.boolean().default(false).catch(false),
  tSorting: requiredSortingSearchParam([{ id: 'name', desc: false }]),
});

export const Route = createFileRoute('/$organizationName/settings/_access/teams')({
  component: TeamsLayout,
  validateSearch: teamsSearchSchema,
});

function TeamsLayout() {
  const { organizationDisplayName } = useUser();
  const isExactMatch = useIsExactRouteMatch(Route.id);

  useEffect(() => {
    if (isExactMatch) {
      document.title = `${organizationDisplayName || 'Driver'} - Teams`;
    }
  }, [organizationDisplayName, isExactMatch]);

  return (
    <SettingsPageLayout fullWidthWithPadding hideSeparator>
      <AdminTeams />
      <Outlet />
    </SettingsPageLayout>
  );
}
